<template>
    <div class="deposit-page">
        <SectionHeader :icon="`icon-deposit`">
            {{$t('deposit') | upperCase}}
        </SectionHeader>
        <Accordion>
            <AccordionItem v-if="isAvailable(DepositType.online)">
                <div slot="title" class="accordion__title">
                    {{ $t('Deposit Online') }}
                </div>
                <div slot="content">
                    <OnlineDeposit />
                </div>
            </AccordionItem>
            <AccordionItem v-if="isAvailable(DepositType.bankTransfer)">
                <div slot="title" class="accordion__title">
                    {{ $t('bank transfer') | capitalize }}
                    <span class="tag">{{ $t('new') | upperCase }}</span>
                </div>
                <div slot="content">
                    <BankTransfer :user="user"/>
                </div>
            </AccordionItem>
            <AccordionItem v-if="isAvailable(DepositType.shop)">
                <div slot="title" class="accordion__title">
                    {{ $t('shop') | capitalize }}
                </div>
                <div slot="content">
                    <Shop/>
                </div>
            </AccordionItem>
            <AccordionItem v-if="isAvailable(DepositType.paySafeCard)">
                <div slot="title" class="accordion__title">
                    {{ $t('paysafecard') | capitalize }}
                </div>
                <div slot="content">
                    <PaySafeCard />
                </div>
            </AccordionItem>
        </Accordion>
        <div class="help-section">
            <div class="section-title">{{ $t('need help to make a deposit') | capitalize }}?</div>
            <div class="notice push_bottom__lg">
                {{ $t('if you have any problems with deposit don\'t hesitate to contact us') | capitalize }}!
            </div>
            <StaticLink
                tag="button"
                class="btn__primary btn__icon--left btn--lg btn--w-90"
                path="help-url"
                label="help"
            >
                <i class="icon icon__lg icon-help_circle btn__icon" />
            </StaticLink>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import config from '@config';
    import Modals from '@store/modules/ui/shared/modal/modals';
    import { DepositType } from '@models/user/enums';
    import {
        OnlineDeposit,
        BankTransfer,
        Shop,
        PaySafeCard,
    } from './AccordionItems';

    export default {
        name: 'DepositContainer',
        created() {
            this.DepositType = DepositType;
            this.checkIfHasWelcomeBonus();
        },
        computed: {
            ...mapGetters('data/authentication', [
                'user',
            ]),
        },
        methods: {
            ...mapActions('ui/modal', [
                'setModal',
            ]),
            checkIfHasWelcomeBonus() {
                if (this.user.welcomeBonus) {
                    this.setModal(Modals.welcomeBonus.code);
                }
            },
            isAvailable(type) {
                return config.countrySpecific.user.deposit.availableTypes[type];
            }
        },
        components: {
            OnlineDeposit,
            BankTransfer,
            Shop,
            PaySafeCard,
        }
    };
</script>



// WEBPACK FOOTER //
// src/app/modules/userProfile/deposit/DepositContainer.vue